export const download = (filenameWithExtension: string, type: string, payload: string) => {
  const element = document.createElement('a');
  const blob = new Blob([payload], {
    type: `${type};charset=utf-8;`,
  });
  const url = URL.createObjectURL(blob);
  element.setAttribute('href', url);
  element.setAttribute('download', filenameWithExtension);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

export const getImage = (base64: string): string => {
  return base64.split(',')[1];
};

export const getImageType = (base64Type: string): string => {
  return base64Type.split('/')[1];
};
